/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import CameraIcon from '@uniiverse/library/assets/icons/camera.svg';
import Config from 'config';
import EditProfileButton from './edit-profile-button';

import { isPrivate } from '../../../modules/profile/getters';

import style from './index-module.css';

type Props = {
  data: ProfileQuery,
  currentUser: Object,
  randomColor: string
};

const CoverPhoto: Function = (props: Props): React$Element<*> => {
  const { data: { profile }, currentUser, randomColor } = props;
  const userOwnsProfile = currentUser && currentUser.id === profile.id;
  let backgroundStyle;

  if (!profile.coverPhotoUrl || (isPrivate(profile) && !userOwnsProfile)) {
    backgroundStyle = { backgroundColor: randomColor };
  }
  else {
    backgroundStyle = {
      backgroundImage: `url(${profile.coverPhotoUrl})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    };
  }

  if (userOwnsProfile) {
    const selectCoverPhoto = () => {
      const input = document.querySelector(`.${style.uploader}`);

      if (input) {
        input.click();
      }
    };
    const uploadCoverPhoto = async () => {
      const input = document.querySelector(`.${style.uploader}`);
      if (!input || !(input instanceof HTMLInputElement) || !input.files[0].size) {
        return;
      }

      const data = new FormData();
      data.append('cover_photo[photo]', input.files[0]);

      await fetch(`${Config.api.host}/account/cover_photo.json`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({ 'X-CSRF-Token': window.sessionStorage.csrf_token }),
        body: data
      });

      window.location.reload();
    };

    return (
      <div className={style.editableContainer}>
        <a className={style.editCoverPhoto} onClick={selectCoverPhoto}>
          <div className={style.coverPhoto} style={backgroundStyle} />
          <input type="file" className={style.uploader} onChange={uploadCoverPhoto} />
          <span className={style.uploadText}>
            <CameraIcon />
            <FormattedMessage id="profile.change-cover-photo" defaultMessage="Change cover photo" />
            <span className={style.uploadTextDescription}>
              <FormattedMessage id="profile.use-this-space" defaultMessage="Use this space to promote your events! (max 2MB)" />
            </span>
          </span>
        </a>
        <EditProfileButton />
      </div>
    );
  }

  // $FlowIssue: property `onClick`. Property not found in props of React element `div` =|
  return <div className={style.coverPhoto} style={backgroundStyle} />;
};

export default CoverPhoto;



// WEBPACK FOOTER //
// ./src/components/profile/cover-photo/index.js